import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const BenefitDetails = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const { feedLink } = location.state || {}; // Get feedLink from navigation state

    if (!feedLink) {
        return <p style={{ color: "red", textAlign: "center" }}>{t('feedlinkavailable')}</p>;
    }

    // Remove "feed" from the URL
    const iframeUrl = feedLink.replace("/feed/", "/");

    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <>
            {/* Back Button */}
           <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
                <button className="win-back-btn me-3" onClick={handleBackClick}>
                    <span>
                        <i className="bi bi-chevron-left"></i> {t('back')}
                    </span>
                </button>
            </div>

            {/* Iframe to load the dynamic URL */}
            <div style={{ marginTop: "20px" }}>
                <iframe
                    src={iframeUrl}
                    title="Benefit Details"
                    style={{
                        width: "100%",
                        height: "80vh",
                        border: "none",
                        borderRadius: "10px",
                    }}
                />
            </div>
            {/* {isChatVisible && <ChatBotWindow />} */}
        </>
    );
};

export default BenefitDetails;
